/**
 * Path under each app's `assets/` root (no leading/trailing slash).
 * - Portal: `assets/${WELCOME_BACKGROUND_DEFAULT_ASSETS_SUBPATH}`
 * - Companion: `../../../assets/${WELCOME_BACKGROUND_DEFAULT_ASSETS_SUBPATH}`
 */
export const WELCOME_BACKGROUND_DEFAULT_ASSETS_SUBPATH = 'images/DefaultBackgroundImage.webp';
